import { CommonModule } from '@angular/common';
import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';

// COMPONENTS
import { ColorPickerModule } from 'ngx-color-picker';

import { SharedComponentsV1Module } from '@app/shared/shared-components-v1.module';

// MODULES
import { MaterialCustomModule } from '../../material-custom.module';
import { SharedComponentsModule } from '../../shared-components.module';
import { DirectiveModule } from '../shared/directives/directive.module';
import { PipeModule } from '../shared/pipes/pipe.module';
import { SharedModule } from '../shared/shared.module';
import { UiModule } from '../ui/ui.module';

import {
  StockComponent,
  StockAgTableComponent,
  StockGroupColumnComponent,
  StockActionsComponent,
  StockSelectAllAgGridComponent,
  StockSidebarComponent,
} from './components';
import { StockStatusLabel } from './pipes/stock-status-label.pipe';

// Services

const components = [
  StockComponent,
  StockAgTableComponent,
  StockGroupColumnComponent,
  StockActionsComponent,
  StockSelectAllAgGridComponent,
  StockSidebarComponent,
];

const vendorModules = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
];

const lumModules = [
  SharedComponentsModule,
  PipeModule,
  MaterialCustomModule,
  UiModule,
  DirectiveModule,
  SharedModule,
  SharedComponentsV1Module,
];

const pipes = [StockStatusLabel];

@NgModule({
  declarations: [...components, ...pipes],
  exports: [...components],
  imports: [...vendorModules, ...lumModules, AgGridModule, ColorPickerModule],
  schemas: [NO_ERRORS_SCHEMA],
})
export class StockModule {}
